module.exports = __webpack_public_path__ + "img/CRT_Sword-002.93a0eb10.png";